import styled from "styled-components"

export const WriteComentArea = styled.fieldset`
  display: flexbox;
  margin: 40px;
  border-radius: 0.5rem;
`
export const ButtonsArea = styled.div`
  display: flex;
  width: 30%;
  justify-content: space-around;
  align-Items: center;
  margin: auto;
`

export const ContentFooter = styled.footer`
  display: flexbox;
  padding-left: 1rem;
  padding-bottom: 1rem;
`;

export const ComemntsArea = styled.ul`
  display: flexbox;
  width: 100%;
  padding-left: 0rem;
`
export const Commentary = styled.li`
  list-style: none;
  display: flex;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  padding: 10px;
`;
